import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import TextField from '@mui/material/TextField'
import styles from './Session.module.css';
import Typography from '@mui/material/Typography';

import { useAppSelector, useAppDispatch } from '../../../app/hooks';
import { useLazyLoginDiscordQuery } from '../../../api/index';
import { useSignupMutation } from '../../../api/auth';
import {
	selectLogged,
} from './sessionSlice';

export function NewUserForm() {
	const navigate = useNavigate()
	const [login, {
		data: result,
		isLoading,
	}] = useSignupMutation()
	const [userNameValue, setUserNameValue] = React.useState('');
	const handleUserNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setUserNameValue(event.target.value);
	};
	const [givenNameValue, setGivenNameValue] = React.useState('');
	const handleGivenNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setGivenNameValue(event.target.value);
	};
	const [familyNameValue, setFamilyNameValue] = React.useState('');
	const handleFamilyNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setFamilyNameValue(event.target.value);
	};
	const [emailValue, setEmailValue] = React.useState('');
	const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setEmailValue(event.target.value);
	};
	const [passwordValue, setPasswordValue] = React.useState('');
	const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setPasswordValue(event.target.value);
	};
	const [passwordConfirmationValue, setPasswordConfirmationValue] = React.useState('');
	const handlePasswordConfirmationChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setPasswordConfirmationValue(event.target.value);
	};
	const [websiteValue, setWebsiteValue] = React.useState('');
	const handleWebsiteChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setWebsiteValue(event.target.value);
	};
	const [locationValue, setLocationValue] = React.useState('');
	const handleLocationChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setLocationValue(event.target.value);
	};
	const [descriptionValue, setDescriptionValue] = React.useState('');
	const handleDescriptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setDescriptionValue(event.target.value);
	};
	let inputDisabled = isLoading ? true : false;

	const onSubmitClicked = async () => {
		console.log("login button pushed", {user: userNameValue });
		try {
			await login({
				name: userNameValue,
				email: emailValue,
				given_name: givenNameValue,
				family_name: familyNameValue,
				password: passwordValue,
				password_confirmation: passwordConfirmationValue,
				i18n: "en-us",
				website: websiteValue,
				location: locationValue,
				description: descriptionValue,
			}).unwrap()
			console.log("whouou signing succeeded");
			navigate("/")
		} catch (err) {
			console.log("error while trying to signin");
		}
	}

	/*
	const onSubmitClicked = () => {
		console.log("login button pushed", {user: userNameValue });
		return (login({//user: {
			name: userNameValue,
			email: emailValue,
			given_name: givenNameValue,
			family_name: familyNameValue,
			password: passwordValue,
			password_confirmation: passwordConfirmationValue,
			i18n: "en-us",
			website: websiteValue,
			location: locationValue,
			description: descriptionValue,
		//}
	}))
	}
	// */

	return (
		<Box sx={{backgroundColor:'blue', margin: 0}} className={styles.row}>
		<Card className={styles.card}>
			<CardContent>
				<Typography variant="h5" className={styles.row}>
					New User Form
				</Typography>
				<Typography variant="body1" className={styles.row}>
					user name: 
				</Typography>
				<TextField
					variant="outlined"
					className={styles.row}
					id="user-name-input"
					disabled={inputDisabled}
					onChange={handleUserNameChange}
				/>
				<Typography variant="body1" className={styles.row}>
					email: 
				</Typography>
				<TextField
					variant="outlined"
					className={styles.row}
					id="email-input"
					disabled={inputDisabled}
					onChange={handleEmailChange}
				/>
				<Typography variant="body1" className={styles.row}>
					password: 
				</Typography>
				<TextField
					variant="outlined"
					type="password"
					className={styles.row}
				/>
				<Typography variant="body1" className={styles.row}>
					password confirmation: 
				</Typography>
				<TextField variant="outlined" type="password"/>
				<Typography variant="body1" className={styles.row}>
					i18n: 
				</Typography>
				<TextField 
					variant="outlined" className={styles.row}
					disabled={true}
				/>
				<Typography variant="body1" className={styles.row}>
					website: 
				</Typography>
				<TextField variant="outlined" className={styles.row}/>
				<Typography variant="body1" className={styles.row}>
					location: 
				</Typography>
				<TextField variant="outlined" className={styles.row}/>
				<Typography variant="body1" className={styles.row}>
					description: 
				</Typography>
				<TextField
					variant="outlined"
					className={styles.textareaautosize}
					id="description-input"
					disabled={inputDisabled}
					multiline={true}
				/>
			</CardContent>
			<CardActions>
				<Button
					size="small"
					onClick={onSubmitClicked}
				>Submit</Button>
			</CardActions>
		</Card>
		</Box>
	);
}

export default NewUserForm;
